import { AssignShipmentType } from "../types/assignShipment.type";

/* eslint-disable camelcase */
export const routeTrapType: Record<string, AssignShipmentType> = {
  delivery_route: "route",
  delivery_trap: "trap",
} as const;

export const planType = {
  DELIVERY_ROUTE: "delivery_route",
  DELIVERY_TRAP: "delivery_trap",
} as const;
